import React, {useEffect} from "react";
import {Breadcrumbs} from "@mui/material";
import reachGoalYM from "@/Helpers/ReachGoalYM";
import reachGoalGA from "@/Helpers/ReachGoalGA";
import BaseLayout from "@/Layouts/BaseLayout";
import Link from "@/Layouts/Link";
import Picture from "@/Components/Picture";
import "@/Scss/Site/B2B/index.scss";

const Index = (props) => {
    const {b2bUrl = ''} = props;

    useEffect(() => {
        reachGoalYM('b2b');
        reachGoalGA('b2b');
    }, []);

    return <BaseLayout {...props}>
        <section className={`section`}>
            <div className={`container`}>
                <Breadcrumbs maxItems={2} itemsAfterCollapse={2} className={`breadcrumbs`}>
                    <Link className={`breadcrumbs__link`} href={`/`}>Главная</Link>
                    <p className={`breadcrumbs__text`}>Бизнес для бизнеса</p>
                </Breadcrumbs>
                <h1 className={`h1`}>Бизнес для бизнеса</h1>
                <div className={`b2b`}>
                    <div className={`b2b-intro`}>
                        <div className={`b2b-intro__image`}>
                            <Picture src={`/storage/img/b2b/image_main.jpg`} alt={`Бизнес для бизнеса`} />
                        </div>
                        <div className={`b2b-intro__text`}>
                            <div className={`description`}>
                                <p>
                                    Получите новые возможности для вашего бизнеса. Станьте партнёром
                                    и&nbsp;начните зарабатывать вместе с&nbsp;брендом PLATINA уже сейчас!
                                </p>
                                <p>
                                    Наши украшения знамениты на&nbsp;рынке ярким, запоминающимся
                                    и&nbsp;уникальным дизайном. Мы&nbsp;гарантируем наивысшее качество,
                                    соответствие свежим трендам ювелирной моды и&nbsp;самый широкий
                                    ассортимент.
                                </p>
                            </div>
                            <a
                                className={`btn btn__b2b mr8`}
                                href={`${b2bUrl}/web-create-account`}
                                target={`_blank`}
                            >
                                Стать партнером
                            </a>
                            <a className={`btn btn__b2b`} href={`${b2bUrl}/web-login`} target={`_blank`}>
                                Личный кабинет партнера
                            </a>
                        </div>
                    </div>
                    <div className={`b2b-advantage`}>
                        <p>
                            Наши преимущества
                        </p>
                    </div>
                    <div className={`list-advantages`}>
                        <div className={`list-advantages__item`}>
                            <Picture src={`/storage/img/b2b/icon_1.png`} alt={`Уникальный дизайн украшений`} />
                            <p className={`text`}>Уникальный дизайн украшений</p>
                        </div>
                        <div className={`list-advantages__item`}>
                            <Picture src={`/storage/img/b2b/icon_2.png`} alt={`Качество и экологичность продукции`} />
                            <p className={`text`}>Качество и экологичность продукции</p>
                        </div>
                        <div className={`list-advantages__item`}>
                            <Picture src={`/storage/img/b2b/icon_3.png`} alt={`Современный подход к производству`} />
                            <p className={`text`}>Современный подход к производству</p>
                        </div>
                        <div className={`list-advantages__item`}>
                            <Picture src={`/storage/img/b2b/icon_4.png`} alt={`Индивидуальный подход к партнерам`} />
                            <p className={`text`}>Индивидуальный подход к партнерам</p>
                        </div>
                        <div className={`list-advantages__item`}>
                            <Picture src={`/storage/img/b2b/icon_5.png`} alt={`Квалифицированные специалисты`} />
                            <p className={`text`}>Квалифицированные специалисты</p>
                        </div>
                        <div className={`list-advantages__item`}>
                            <Picture src={`/storage/img/b2b/icon_6.png`} alt={`Коллекции украшений на любой вкус`} />
                            <p className={`text`}>Коллекции украшений на любой вкус</p>
                        </div>
                        <div className={`list-advantages__item`}>
                            <Picture
                                src={`/storage/img/b2b/icon_7.png`}
                                alt={`Наличие и постоянное пополнение ассортимента`}
                            />
                            <p className={`text`}>Наличие и постоянное пополнение ассортимента</p>
                        </div>
                        <div className={`list-advantages__item`}>
                            <Picture
                                src={`/storage/img/b2b/icon_8.png`}
                                alt={`Юридическая безопасность сотрудничества`}
                            />
                            <p className={`text`}>Юридическая безопасность сотрудничества</p>
                        </div>
                    </div>
                </div>
            </div>
        </section>
    </BaseLayout>
}

export default Index;
